import React, { Component } from 'react'
import CSSModules from 'react-css-modules'
import config from '../../config'
import {
  ContainerDivs,
  Link,
} from '../'
import Styles from './RiskTypeLinks.css'

@CSSModules(Styles,{allowMultiple:true})
export default class RiskTypeLinks extends Component {
  render() {
    return (
      <div styleName='gray-wrap'>
        <ContainerDivs>
          <h2 styleName='section-lbl'>
            How unsustainable funds threaten your retirement
          </h2>
          <div styleName='risk-type-links-flex'>
            <div styleName='risk-type-links-cell-outer'>
              <Link
                to={config.routes.issues}
                title='Environmental and social impacts'
              >
                <div styleName='risk-type-links-cell-inner'>
                  <div styleName='risk-type-links-image clim' />
                  <div styleName='risk-type-links-hl-flex'>
                    <h3 styleName='risk-type-links-hl'>
                      Environmental and social impacts
                    </h3>
                  </div>
                  <div styleName='risk-type-links-tl'>
                    We rate retirement plans and mutual funds on
                    environmental and social sustainability issues, from
                    deforestation to gender equality. <span
                      styleName='risk-type-links-read-more'
                    >Read more</span>
                  </div>
                </div>
              </Link>
            </div>
            <div styleName='risk-type-links-cell-outer'>
              <Link
                to={config.routes.eduCenterFinRisks}
                title='Financial risks of unsustainable investments'
              >
                <div styleName='risk-type-links-cell-inner'>
                  <div styleName='risk-type-links-image fin' />
                  <div styleName='risk-type-links-hl-flex'>
                    <h3 styleName='risk-type-links-hl'>
                      Financial risks of unsustainable investments
                    </h3>
                  </div>
                  <div styleName='risk-type-links-tl'>
                    Unsustainable investments could be adding financial risk
                    to your 401(k). Learn the facts about sustainable
                    investing and performance. <span
                      styleName='risk-type-links-read-more'
                    >Read more</span>
                  </div>
                </div>
              </Link>
            </div>
          </div>
        </ContainerDivs>
      </div>
    )
  }
}